import { Injectable, EventEmitter, Output } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";

import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { Data } from "./data.model";

@Injectable()
export class CommonSerService {
  TaskData = new EventEmitter<any>()
  Value = new EventEmitter<Data>();
  handleError(data: any) {
    const newData = new Data(data);
    this.Value.emit(newData);
  }
  ModuleData = new EventEmitter<any>();
  responce: Response;
  ListofProjectData = new EventEmitter<any>();
  DocumentData = new EventEmitter<any>();
  constructor(private http: HttpClient, private dsolveialog: MatDialog, private router: Router) { }
  Url = "https://api.sagiam.com";
 // Url = "http://192.168.1.129:4000";
  // Url = "http://localhost:4000";


  welcome_title: string = 'Welcome to ';
  welcome_head: string = 'Sagiam';
  welcome_sub_title: string = 'Your business automation software';
  urlforMaster_Dashboad = "/Master_Dashboad";
  url_user_Login = "/Login";
  urlforListAllEmployees = "/List_All_Employee";
  urlforCreateEmployee = "/Create_Employee";
  urlforListAll_Active_Departments = "/List_All_Departments";
  urlforListAll_In_Active_Departments = "/List_Al l_Inactive_Departments";
  urlfor_Create_Department = "/Create_Department";
  urlforListAllTechnologies = "/List_All_Technologies";
  urlforCreateTechnology = "/Create_Technology";
  urlforEmmpTechnologiesMaster_Dashboard = "/List_All_Employee_Technologies_Master_Dashboard";
  AddTechnologyEmployee = "/Add_Technology_Employee";
  Url_of_List_All_Projects = "/List_All_Projects";
  Url_of_Update_Password = "/Update_Password";
  CreateProjectform = "/Create_Project";
  Url_of_List_All_Project_Applications = "/List_All_Project_Applications";
  Url_of_Add_Project_Application = "/Add_Project_Application";
  Url_of_List_All_Modules = '/List_All_Modules';
  Url_of_Create_Module = '/Create_Module';
  Url_of_Upload_Document = '/Upload_Document';
  Url_of_Create_Task = '/Create_Task';
  Url_of_List_All_Tasks = '/List_All_Tasks';
  Url_of_Start_Task = '/Start_Task';
  Url_of_Pause_Task = '/Pause_Task';
  Url_of_Resume_Task = '/Resume_Task';
  Url_of_Complete_Task = '/Complete_Task';
  Url_of_List_All_Task_Intervals = '/List_All_Task_Intervals';
  Url_of_Forgot_Password = '/Forgot_Password';
  Url_of_Remove_Employee = '/Remove_Employee';
  Url_of_Add_Manager = '/Add_Manager';
  Url_of_List_All_Managers = '/List_All_Managers';
  Url_of_List_All_Teams = '/List_All_Teams';
  Url_of_Create_Team = '/Create_Team';
  Url_of_List_Only_Employee = '/List_Only_Employee';
  Url_of_Remove_As_Manager = '/Remove_As_Manager';
  Url_of_Add_Employee_Team = '/Add_Employee_Team';
  Url_of_List_All_Team_Members = '/List_All_Team_Members';
  Url_of_Manager_List_All_Teams = '/Manager_List_All_Teams';
  Url_of_Inactivate_Team = '/Inactivate_Team';
  Url_of_Get_First_Last_Activity_Year = '/Get_First_Last_Activity_Year';
  Url_of_Employee_List_All_Activity_Logs_By_Year = '/Employee_List_All_Activity_Logs_By_Year';
  Url_of_Manager_List_All_Teams_Employee_Dashboard = '/Manager_List_All_Teams_Employee_Dashboard';
  Url_of_Add_Manager_Team = '/Add_Manager_Team';
  Url_of_List_All_Client_Projects = '/List_All_Client_Projects';
  Url_of_Create_Event = '/Create_Event';
  Url_of_List_All_Events = '/List_All_Events';
  Url_of_Add_Event_Member = '/Add_Event_Member';
  Url_of_List_All_Event_Members = '/List_All_Event_Members';
  Add_Event_Contact_Comment = '/Add_Event_Contact_Comment';
  Url_of_Add_Continent = '/Add_Continent';
  Url_of_List_All_Continents = '/List_All_Continents';
  Url_of_Validity_Continent_Number = '/Validity_Continent_Number';
  Url_of_Add_Industry = '/Add_Industry';
  Url_of_List_All_Industries = '/List_All_Industries';
  Url_of_List_All_Business_Teams = '/List_All_Business_Teams';
  Url_of_Validate_Business_Team_Number = '/Validate_Business_Team_Number';
  Url_of_Create_Business_Team = '/Create_Business_Team';
  Url_of_List_Only_Technology_Employees = '/List_Only_Technology_Employees';
  Url_of_List_All_Business_Managers = '/List_All_Business_Managers';
  Url_of_List_Only_Business_Employees = '/List_Only_Business_Employees';
  Url_of_Add_Business_Manager = '/Add_Business_Manager';
  Url_of_Add_Business_Employee_Team = '/Add_Business_Employee_Team';
  Url_of_List_All_Countries = '/List_All_Countries';
  Url_of_Validate_Access_Token = '/Validate_Access_Token';
  Url_of_Search_Companies = '/Search_Companies';
  Url_of_Validate_Lead_Website = '/Validate_Lead_Website';
  Url_of_List_All_States = '/List_All_States';
  Url_of_List_All_Cities = '/List_All_Cities';
  Url_of_List_All_Leads = '/List_All_Leads';
  Url_of_Add_Business_Lead = '/Add_Business_Lead';
  Add_Company_Lead_Comment = '/Add_Company_Lead_Comment'
  Store_Employee_Last_Profile = '/Store_Employee_Last_Profile'
  Url_of_Add_Company_Contacts_from_URL = '/Add_Company_Contacts_from_URL';
  Url_of_List_All_Scraping_URL_Requests = '/List_All_Scraping_URL_Requests';
  Url_of_List_All_URL_Request_Contacts = '/List_All_URL_Request_Contacts';
  Url_of_List_All_Blog_Posts = '/List_All_Blog_Posts';
  Url_of_Add_Blog_Post = '/Add_Blog_Post';
  Url_of_Blog_Post_Detailed_View = '/Blog_Post_Detailed_View';
  Url_of_Submit_Comment = '/Submit_Comment';
  Url_of_Search_All_Employees_for_Share = '/Search_All_Employees_for_Share';
  Url_of_Share_Blog_Post_with_Employees = '/Share_Blog_Post_with_Employees';
  Url_of_List_All_HR_Employees = '/List_All_HR_Employees';
  Url_of_Assign_Hr_Employee = '/Assign_Hr_Employee';
  Url_of_List_All_HR_Assign_Employees = '/List_All_HR_Assign_Employees';
  Url_of_List_Remove_HR_Assign_Employee = '/Remove_HR_Assign_Employee';
  Url_of_Employee_Attendance_Login = '/Employee_Attendance_Login';
  Url_of_Get_Employee_Today_Attendance_Status = '/Get_Employee_Today_Attendance_Status';
  Url_of_Employee_Attendance_Logout = '/Employee_Attendance_Logout';
  Url_of_Get_HR_Month_Calender_Days = '/Get_HR_Month_Calender_Days';
  Url_of_Get_All_Assigned_Employee_with_Attendance_Status_By_Date = '/Get_All_Assigned_Employee_with_Attendance_Status_By_Date';
  Url_of_HR_Approve_Employee_Login_Time = '/HR_Approve_Employee_Login_Time';
  Url_of_HR_Approve_Employee_Logout_Time = '/HR_Approve_Employee_Logout_Time';
  Url_of_Get_Employee_Attendance_Status_for_Last_7_Days = '/Get_Employee_Attendance_Status_for_Last_7_Days';
  Url_of_Change_Employee_Permissions = '/Change_Employee_Permissions';
  Url_of_HR_List_All_Employee_Working_Projects_by_Date = '/HR_List_All_Employee_Working_Projects_by_Date';
  Url_of_HR_List_All_Employee_Working_Project_Tasks_by_Date = '/HR_List_All_Employee_Working_Project_Tasks_by_Date';
  Url_of_HR_List_All_Employee_Task_Intervals = '/HR_List_All_Employee_Task_Intervals';
  Url_of_HR_Edit_Employee_Login_Time = '/HR_Edit_Employee_Login_Time';
  Url_of_HR_Edit_Employee_Logout_Time = '/HR_Edit_Employee_Logout_Time';
  Url_of_List_All_Unassigned_Hr_Employees = '/List_All_Unassigned_Hr_Employees';
  Url_of_Get_Employee_Attendance_Hours_and_Working_Hours_between_Dates = '/Get_Employee_Attendance_Hours_and_Working_Hours_between_Dates';
  Url_of_Get_Employee_Points_Analytics_between_Dates = '/Get_Employee_Points_Analytics_between_Dates';
  Url_of_List_All_Employee_Notifications = '/List_All_Employee_Notifications';
  Url_of_Employee_Notification_Viewed = '/Employee_Notification_Viewed';
  Url_of_Get_LeaderBoard_By_Month_Year = '/Get_LeaderBoard_By_Month_Year';
  Url_of_HR_List_All_Employee_Working_R_D_Modules_by_Date = '/HR_List_All_Employee_Working_R_D_Modules_by_Date';
  Url_of_HR_List_All_Employee_Working_R_D_Tasks_by_Date = '/HR_List_All_Employee_Working_R_D_Tasks_by_Date';
  Url_of_Get_Employee_Points_Logs_By_Month_Year = '/Get_Employee_Points_Logs_By_Month_Year';
  Url_of_Get_List_All_Employee_Activities_Attendance_Task_Log_Personal_Task_By_Date = '/List_All_Employee_Activities_Attendance_Task_Log_Personal_Task_By_Date'
  Url_of_Update_Employee_Image = '/Update_Employee_Image'


  // ProjectView API's
  Url_of_List_All_Projects_Detailed = '/List_All_Projects_Detailed';
  Url_of_Create_Project_with_Detailed_Information = '/Create_Project_with_Detailed_Information';
  Url_of_Upload_Image = '/Upload_Image';
  Url_of_Get_Project_Overview_Analytics = '/Get_Project_Overview_Analytics';
  Url_of_Validate_Project_Application_Number = '/Validate_Project_Application_Number';
  Url_of_Validity_Module_Number = '/Validity_Module_Number';
  Url_of_List_All_Employee_Recent_Project_Applications = '/List_All_Employee_Recent_Project_Applications';
  Url_of_List_All_Clients = '/List_All_Clients';
  Url_of_Create_Client = '/Create_Client';
  Url_of_Master_List_All_Projects = '/Master_List_All_Projects';
  Url_of_Add_Client_Project = '/Add_Client_Project';
  Update_Task_Completion_Status = '/Update_Task_Completion_Status';
  Url_of_Search_All_Assigned_Employee_with_Attendance_Status_By_Date = '/Search_All_Assigned_Employee_with_Attendance_Status_By_Date';
  Url_of_Filter_All_Assigned_Employee_with_Attendance_Status_By_Date_By_Query = '/Filter_All_Assigned_Employee_with_Attendance_Status_By_Date_By_Query';


  //Project Manager 

  // Interview Schedules
  Url_of_List_All_Interview_Profiles = '/List_All_Interview_Profiles';
  Url_of_Hr_Add_Interview_Profile = '/Hr_Add_Interview_Profile';
  Url_of_Create_Interview = '/Create_Interview';
  Url_of_List_All_Interviews = '/List_All_Interviews';
  Url_of_List_All_Interview_Candidates = '/List_All_Interview_Candidates';
  Url_of_Add_Interview_Candidate = '/Add_Interview_Candidate';
  Url_of_Schedule_Interview = '/Schedule_Interview';
  Url_of_Postponed_Rescheduled_Interview = '/Postponed_Rescheduled_Interview';
  Url_of_Progress_or_Start_Interview = '/Progress_or_Start_Interview';
  Url_of_List_All_Interview_Schedules = '/List_All_Interview_Schedules';
  Url_of_Schedule_Candidate_Interview = '/Schedule_Candidate_Interview';
  Url_of_Update_Candidate_Interview_Status = '/Update_Candidate_Interview_Status';
  Url_of_List_All_Interview_Schedule_Logs_With_Filter = '/List_All_Interview_Schedule_Logs_With_Filter';
  Url_of_Search_Interview = '/Search_Interview';
  Url_of_Search_Interview_Profiles = '/Search_Interview_Profiles';


  Manager_List_All_Teams = '/Manager_List_All_Teams';
  Manager_List_All_Team_Members = '/Manager_List_All_Team_Members'
  Manager_List_All_Employee_Projects = '/Manager_List_All_Employee_Projects';
  Manager_List_All_Employee_Project_Applications = '/Manager_List_All_Employee_Project_Applications';
  Manager_List_All_Employee_Project_Application_Modules = '/Manager_List_All_Employee_Project_Application_Modules';
  Manager_List_All_Employee_Project_Application_Module_Tasks = '/Manager_List_All_Employee_Project_Application_Module_Tasks';
  Manager_List_All_Employee_Task_Intervals = '/Manager_List_All_Employee_Task_Intervals';
  Url_of_Technical_Manager_List_All_Client_Queries = '/Technical_Manager_List_All_Client_Queries';

  //Research and Development Modules

  List_All_Research_Development_Modules = '/List_All_Research_Development_Modules'

  List_All_Research_Development_Tasks = '/List_All_Research_Development_Tasks'

  List_All_Research_Development_Task_Intervals = '/List_All_Research_Development_Task_Intervals'
  Url_of_Create_Research_Development_Module = '/Create_Research_Development_Module';
  Url_of_Create_Research_Development_Task = '/Create_Research_Development_Task';
  Url_of_Start_Research_Development_Task = '/Start_Research_Development_Task';
  Url_of_Pause_Research_Development_Task = '/Pause_Research_Development_Task';
  Url_of_Resume_Research_Development_Task = '/Resume_Research_Development_Task';
  Url_of_Complete_Research_Development_Task = '/Complete_Research_Development_Task';
  Url_of_Update_R_D_Task_Completion_Status = '/Update_R_D_Task_Completion_Status';

  //Evontex Website APIS

  List_All_Evontex_Website_Contacts = '/List_All_Evontex_Website_Contacts'

  List_All_Evontex_Website_Questionnaires = '/List_All_Evontex_Website_Questionnaires'

  // ADA APIS
  Url_of_Add_ADA_Employees = '/Add_ADA_Employees';
  Url_of_List_All_ADA_Employees = '/List_All_ADA_Employees';
  Url_of_Add_ADA_Claims = '/Add_ADA_Claims';
  Url_of_List_All_ADA_Claims = '/List_All_ADA_Claims';
  Url_of_List_All_ADA_Employee_Claimed_Claims = '/List_All_ADA_Employee_Claimed_Claims';
  Url_of_Update_Employee_Claim_Status = '/Update_Employee_Claim_Status';
  Url_of_Remove_ADA_Employee = '/Remove_ADA_Employee';

  // Client APIS
  Url_of_Client_List_All_Issues = '/Client_List_All_Issues';
  Url_of_Client_Create_Issue = '/Client_Create_Issue';
  Url_of_Client_List_All_Queries = '/Client_List_All_Queries';
  Url_of_Client_Create_Query = '/Client_Create_Query';
  Url_of_Client_List_All_Project_Modules_By_Month_Year = '/Client_List_All_Project_Modules_By_Month_Year';
  List_All_Project_Applications_with_Progress = '/List_All_Project_Applications_with_Progress';
  Url_of_Project_Work_Analytics = '/Project_Work_Analytics';
  Url_of_Project_Issue_Analytics = '/Project_Issue_Analytics';
  Url_of_Project_Time_Analytics_Application_Wise = '/Project_Time_Analytics_Application_Wise';
  Url_of_Project_Time_Analytics_Department_Wise = '/Project_Time_Analytics_Department_Wise';
  Url_of_Client_View_Timeline_Inside_Projects = '/Client_View_Timeline_Inside_Projects';
  Url_of_Client_View_Timeline_Inside_Applications = '/Client_View_Timeline_Inside_Applications';
  Application_Time_Analytics_Module_Wise = '/Application_Time_Analytics_Module_Wise';
  Application_Work_Analytics = '/Application_Work_Analytics';
  Application_Issue_Analytics = '/Application_Issue_Analytics';
  Application_Time_Analytics_Department_Wise = '/Application_Time_Analytics_Department_Wise';
  List_All_Module_Tasks = '/List_All_Module_Tasks';
  Module_Work_Analytics = '/Module_Work_Analytics';
  Module_Issue_Analytics = '/Module_Issue_Analytics';
  Module_Time_Analytics_Department_Wise = '/Module_Time_Analytics_Department_Wise'
  Module_Time_Analytics_Top5_Tasks = '/Module_Time_Analytics_Top5_Tasks'
  Client_View_Timeline_Inside_Module = '/Client_View_Timeline_Inside_Module';
  Url_of_Client_Issue_Response = '/Client_Issue_Response';
  Url_of_Client_Issue_Responses_in_Detail = '/Client_Issue_Responses_in_Detail';
  Project_Time_Analytics_Technology_Wise = '/Project_Time_Analytics_Technology_Wise';
  Application_Time_Analytics_Technology_Wise = '/Application_Time_Analytics_Technology_Wise';
  Module_Time_Analytics_Technology_Wise = '/Module_Time_Analytics_Technology_Wise'

  Block_Sagiam_Website_Contact = '/Block_Sagiam_Website_Contact'
  Unblock_Sagiam_Website_Contact = '/Unblock_Sagiam_Website_Contact'



  public checknull_value(valuex: string, minlenth: Number) {
    if (valuex != null) {
      if (valuex.length <= minlenth || valuex == "") {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  public ValidateEmail(inputText) {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (inputText.value.match(mailformat)) {
      return true;
    } else {
      return false;
    }
  }

  public mrthod(url: String, value: Object): Observable<any> {
    let bodyString = value;

    return this.http
      .post(this.Url + url, bodyString, {
        headers: new HttpHeaders().set("Content-Type", "application/json") // adding headers to request
      }) // ...using post request
      .map(res => {
        var red: any = [];
        red = res;
        var succ = red.success;
        if (succ) {
          return res;
        } else {
          if (red.extras.msg == 10) {
            localStorage.removeItem('UserValues')
            this.router.navigateByUrl("/login-module")
            return res;
            //
          } else {
            return res;
          }
          // return alert(JSON.stringify(res));
        }
      }) // ...now we return data
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      );
  }

  ConvertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = '';

    for (var index in objArray[0]) {
      //Now convert each value to string and comma-separated
      row += index + ',';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
      var line = '';
      for (var index in array[i]) {
        if (line != '') line += ','

        line += array[i][index];
      }
      str += line + '\r\n';
    }
    return str;
  }

  makeFileRequests(url: string, file) {
    return Observable.create(observer => {
      let formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();
      formData.append('file', file);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();

          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.upload.onprogress = (event) => {
      };
      xhr.open('POST', url, true);
      xhr.send(formData);
    });
  }

  ApiMessages = [
    "",
    "Database Error",
    "Enter All Tags",
    "Invalid Secret Code",
    "Invalid email format",
    "Email already exist",
    "Email not found",
    "Invalid password",
    "Password tries exceeded",
    "Admin inactive not found",
    "Session expired",
    "Employee id already exist",
    "Employee not found",
    "Employee not active",
    "Forgot password tries exceeded",
    "Department not found",
    "Department not active",
    "Technology not found",
    "Technology not active",
    "Employee already exist",
    "Number already exist",
    "Project not found",
    "Project not active",
    "Project application not found",
    "Project aplication not active",
    "Request size exceeded",
    "Invalid file",
    "Document not found",
    "Document already used",
    "Module not found",
    "Module not active",
    "Employee not avalable in technology",
    "Task not found",
    "Task not active",
    "Task already started",
    "Invalid privileges",
    "Task already paused",
    "Task cancelled",
    "Task completed",
    "Task not paused",
    "Task already completed",
    "Task not started",
    "Task already cancelled",
    "Already manager",
    "Team number already exist",
    "Team not found",
    "Employee is not manager",
    "Manager already assigned",
    "Manager not found",
    "Manager not active",
    "Image already used",
    "Image not found",
    "Client not found",
    "Project already exist",
    "Client already exist",
    "Team already exist",
    "Event not found",
    "Submit Atleast One Employee Role",
    "Continent Not Found",
    "Not Business Employee",
    "Country Not Found",
    "State Not Found",
    "City Not Found",
    "Linkedin Error",
    "Lead Already Exist",
    "You dont have Business Manager Rights to your Account",
    "Contact Not Found",
    "Invalid Source Type",
    "Request URL Not Found",
    "Lead not Found",
    "Post Not Found",
    "Rating already submitted",
    "Invalid Rating",
    "Not HR priviliges",
    "Employee and HR must be different",
    "Relation already exist",
    "Employee already Assign to another HR",
    "HR not found",
    "Already login",
    "Attendance not found",
    "Already Sign out",
    "Invalid Time",
    "Already approved",
    "Invalid Privileges",
    "Task not completed",
    "Already task reviewed",
    "Resume Already Used",
    "Resume Not Found",
    "Profile Already Exist",
    "Profile Not Found",
    "Interview Not Found",
    "Interview Already Scheduled",
    "Interview Already Completed",
    "Interview Already Cancelled",
    "Interview Scheduling Needed Atleast One Profile",
    "Candidate Not Found",
    "Candidate Already Exist",
    "Rescheduled Time Must be Atleast  Hours After Current Time",
    "Rescheduled Time Must be Atleast Either  Hours Before or After Existing Scheduled Time",
    "Interview Already Progressed",
    "Interval Not found",
    "Claim Already Exist",
    "Claim Not Found",
    "Claim Already Initiated",
    "Claim Already Approved",
    "Claim Already Transferred",
    "Amount Exceeded Claim Limit",
    "Employee Claim Not Found",
    "From Date Must Be Less Than To Date",
    "Point must be between 100 and 2000",
    "Issue not found",
    "Issue already reviewed",
    "Issue already assigned to developer",
    "Issue already progressed",
    "Issue resolved",
    "Issue cancelled",
    "Issue progress not available"
  ];

  logOutEmp() {
    localStorage.removeItem('UserValues');
    localStorage.setItem('isLogined', 'false');
    localStorage.removeItem('DocumentsData');
    localStorage.setItem('DocumentsAvailable', 'false');
    localStorage.removeItem('ModuleData');
    localStorage.removeItem('TaskData');
    localStorage.removeItem('ProjectDataView');
    localStorage.removeItem('ApplicationDataView');
    localStorage.removeItem('ModuleDataView');
    this.router.navigateByUrl('/login-module');
    localStorage.removeItem('UserValues')
    localStorage.setItem('isLogined', 'false')
    localStorage.removeItem('DocumentsData')
    localStorage.setItem('DocumentsAvailable', 'false')
    localStorage.removeItem('ModuleData')
    localStorage.removeItem('TaskData')
    localStorage.removeItem('ProjectDataView')
    localStorage.removeItem('ApplicationDataView')
    localStorage.removeItem('ModuleDataView')
    localStorage.removeItem('EventID')
    localStorage.removeItem('PostData')
    localStorage.removeItem('Interview')
    localStorage.removeItem('Description')
    this.router.navigateByUrl('/login-module')
    return;
  }
  logOutAdmin() {
    localStorage.removeItem('EmployeeManager');
    localStorage.removeItem('createTeam');
    localStorage.removeItem('SECRETCODE_TOOL');
    localStorage.removeItem('TeamData');
    this.router.navigateByUrl('/master');
    return;
  }
}



// WEBPACK FOOTER //
// D:/Venkat Projects/sagiam-tool-angular/src/app/common-ser.service.ts